// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sub-el-icon[data-v-3a29a558] {\n  color: currentColor;\n  width: 1em;\n  height: 1em;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
